
import {
  defineComponent,
  ref,
  onMounted,
} from 'vue';
import BackgroundPattern from '@/components/BackgroundPattern.vue';

export default defineComponent({
  components: {
    BackgroundPattern,
  },
  props: {
    background: {
      type: String,
      required: false,
      default: () => 'bg-gray-gradient',
    },
    spacer: {
      type: String,
      required: false,
      default: () => 'none',
    },
    spacerCloudsPlacement: {
      type: String,
      required: false,
      default: () => 'bottom',
    },
    spacerBarAlign: {
      type: String,
      required: false,
      default: () => 'right',
    },
  },

  setup() {
    const pattern = ref<InstanceType<typeof HTMLElement>>();

    const {
      ioappConfig: {
        themeUri,
      },
    } = window;

    onMounted(() => {
      if (pattern.value) {
        pattern.value.style.backgroundImage = `url('${themeUri}/assets/img/hero-pattern.svg')`;
      }
    });

    return {
      pattern,
    };
  },
});
